import { Component, OnInit } from '@angular/core';
import * as moment from "moment";
import { UsuarioService } from '../../services/usuario.service';
import { MatDialog } from '@angular/material';
import { UsuarioSecundarioDetalleComponent } from '../usuario-secundario-detalle/usuario-secundario-detalle.component';
import { CookieService } from 'ngx-cookie-service';
import { OpcionUsuarioSecundarioComponent } from '../opcion-usuario-secundario/opcion-usuario-secundario.component';

@Component({
  selector: 'app-usuario-secundario-listado',
  templateUrl: './usuario-secundario-listado.component.html',
  styleUrls: ['./usuario-secundario-listado.component.css']
})
export class UsuarioSecundarioListadoComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    private usuarioService: UsuarioService,
    private cookieService: CookieService
  ) { }

  columnsToDisplay = [];
  columnasVisibles = [];
  loading: boolean = false;
  dataSource = [];

  ngOnInit() {
    this.inicializarGrilla();
    this.inicializar();
  }

  inicializarGrilla() {
    this.columnsToDisplay = [
      { nombre: "permiso", titulo: "", visible: true, tipo: "string" },
      { nombre: "editar", titulo: "", visible: true, tipo: "string" },
      // { nombre: "eliminar", titulo: "", visible: true, tipo: "string" },
      { nombre: "usuario", titulo: "Usuario", visible: true, tipo: "string" },
      { nombre: "nombreCompleto", titulo: "Nombre del Usuario", visible: true, tipo: "string" },
      { nombre: "tipoDocumento", titulo: "Tipo Documento", visible: true, tipo: "string" },
      { nombre: "nroDocumento", titulo: "Nro. Documento", visible: true, tipo: "string" },
      { nombre: "correo", titulo: "Correo", visible: true, tipo: "string" },
      { nombre: "estado", titulo: "Estado", visible: true, tipo: "string" }
    ];
    this.columnasVisibles = this.columnasParaMostrar(this.columnsToDisplay);
  }

  columnasParaMostrar(columnas) {
    var columnasVisibles = columnas.filter(c => {
      return c.visible;
    });
    var nombreColsVisibles = columnasVisibles.map(c => {
      return c.nombre;
    });
    return nombreColsVisibles;
  }

  formatearColumna(element, column) {
    switch (column.tipo) {
      case "date":
        return element[column.nombre] ? moment(element[column.nombre]).format("DD/MM/YYYY") : "";
      case "decimal":
        return parseFloat(element[column.nombre]).toFixed(column.fixed);
      default:
        return element[column.nombre];
    }
  }

  classHeaderColumna(columna) {
    return "xs-header-cell";
  }

  inicializar(){
    /*this.usuarioService.listar({ruc: this.cookieService.get("usuarioRuc")}).then(res =>{
      this.dataSource = res.data.listaUsuario;
    });*/
  }

  onClickAgregar(){
    const param = {opcion: "AGREGAR"};
    this.mostrarDialogoUsuario(param);
  }

  onClickModificar(e){
    const param = {opcion: "MODIFICAR", idUsuarioRuc: e.idUsuarioRuc};
    this.mostrarDialogoUsuario(param);
  }

  onClickEliminar(e){
    const param = {opcion: "ELIMINAR", idUsuarioRuc: e.idUsuarioRuc};
    this.mostrarDialogoUsuario(param);
  }

  onClickPermiso(e){
    const param = {idUsuario: e.idUsuario};
    this.mostrarDialogoOpcion(param);
  }

  /*--------------------------------------------------------------------------*/
  /*---------------------------- DIALOGOS (MODAL) ----------------------------*/
  /*--------------------------------------------------------------------------*/
  mostrarDialogoUsuario(params) {
    const dialogRef = this.dialog.open(UsuarioSecundarioDetalleComponent, {
      width: '850px',
      height: '100px',
      panelClass: "xs-dlg-base",
      disableClose: true,
      data: params,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.estado == "ACEPTAR")
        this.inicializar();
    });
  }

  mostrarDialogoOpcion(params) {
    const dialogRef = this.dialog.open(OpcionUsuarioSecundarioComponent, {
      width: '610px',
      height: '100px',
      panelClass: "xs-dlg-base",
      disableClose: true,
      data: params,
    });
  }
}
